import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

import { WA_WINDOW } from '@ng-web-apis/common';

import { APPLICATION_ROUTES } from '@core/consts/routes';
import { SVG } from '@core/consts/SVGs';
import { IS_DESKTOP, IS_MOBILE, IS_TABLET } from '@core/tokens/tokens';
import { UserStateService } from '@core/services/authApiService/user-state-service.service';

import { NamedLogoComponent } from '../named-logo/named-logo.component';
import { ContactsComponent } from '../contacts/contacts.component';
import { HeaderActionContentComponent } from './header-action-content/header-action-content.component';
import { AgreementsLinksComponent } from '../agreements-links/agreements-links.component';

const MOBILE_BREAKPOINT = 768;

@Component({
  selector: 'mdcr-header',
  imports: [NamedLogoComponent, ContactsComponent, HeaderActionContentComponent, AgreementsLinksComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  private readonly isDesktop = inject(IS_DESKTOP);

  private readonly userStateService = inject(UserStateService);

  private readonly window = inject(WA_WINDOW);
  private readonly isTablet = inject(IS_TABLET);
  private readonly isMobile = inject(IS_MOBILE);
  private readonly router = inject(Router);
  private readonly elementRef = inject(ElementRef);

  public readonly isLogged = this.userStateService.isLoggedIn;

  public readonly SVG = SVG;

  public readonly showFlag = signal(false);
  public readonly isDesktopLayout = signal(true);

  public ngOnInit(): void {
    this.checkViewport();

    switch (true) {
      case this.isMobile: {
        this.elementRef.nativeElement.style.setProperty('--header-height', '56px');
        break;
      }
      case this.isTablet: {
        this.elementRef.nativeElement.style.setProperty('--header-height', '64px');
        break;
      }
      default: {
        this.elementRef.nativeElement.style.setProperty('--header-height', '93px');
      }
    }
  }

  public goToMainPage(): void {
    this.router.navigateByUrl(APPLICATION_ROUTES.root);
  }

  public setShowFlag(): void {
    this.showFlag.set(!this.showFlag());
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    this.checkViewport();
  }

  private checkViewport(): void {
    this.isDesktopLayout.set(this.isDesktop && this.window.innerWidth > MOBILE_BREAKPOINT);
    if (this.isDesktopLayout()) {
      this.showFlag.set(false);
    }
  }
}
